"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUIRED_BUSINESS_DETAIL_LABELS = exports.REQUIRED_BUSINESS_DETAIL_KEYS = void 0;
exports.validateRequiredBusinessDetails = validateRequiredBusinessDetails;
exports.REQUIRED_BUSINESS_DETAIL_KEYS = [
    'businessName',
    'vatNumber',
    'taxOffice',
    'phone',
];
exports.REQUIRED_BUSINESS_DETAIL_LABELS = {
    businessName: 'Επωνυμία',
    vatNumber: 'ΑΦΜ',
    taxOffice: 'ΔΟΥ',
    phone: 'Τηλέφωνο',
};
function validateRequiredBusinessDetails(form) {
    for (const key of exports.REQUIRED_BUSINESS_DETAIL_KEYS) {
        const value = form[key];
        if (value == null || String(value).trim() === '') {
            return `Το πεδίο «${exports.REQUIRED_BUSINESS_DETAIL_LABELS[key]}» είναι υποχρεωτικό.`;
        }
    }
    return null;
}
